<template>
  <div class="confirm-device__container">
    <div class="confirm-device__body">
      <div class="confirm-device__body__device-title" style="font-weight: bold">
        {{ $t('product_form.are_you_sure_device') }}
      </div>

      <div class="confirm-device__body__description">
        {{ $t('product_form.description') }}
      </div>

      <div class="confirm-device__body__device-name">
        {{ $t('product_form.selected_device') }}
        <div class="confirm-device__body__device-name__name">
          {{ selectedDevice && selectedDevice.name }}
        </div>
      </div>

      <div class="confirm-device__body__device-name">
        {{ $t('product_form.user_device') }}
        <div class="confirm-device__body__device-name__name">
          {{ identifiedUserDeviceName }}
        </div>
      </div>

      <div class="confirm-device__body__actions">
        <button class="confirm-device__back" @click="returnToSelectDevice">
          {{ $t('product_form.negative_answer_device') }}
        </button>

        <button class="confirm-device__next" @click="confirmDeviceModal">
          {{ $t('product_form.positive_answer_device') }}
        </button>
      </div>

      <div
        v-if="isAndroid"
        class="confirm-device__body__discover-device"
        @click.prevent="showExplainPhoneType"
      >
        {{ $t('product_form.dont_know_my_device') }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedDevice: {
      type: Object,
      default: () => {},
    },
    selectedBrand: {
      type: Object,
      default: () => {},
    },
    identifiedUserDeviceName: {
      type: String,
      default: '',
    },
  },
  computed: {
    isAndroid() {
      return ['Samsung', 'Motorola', 'Xiaomi', 'Realme'].includes(
        this.selectedBrand?.name
      )
    },
  },
  methods: {
    showExplainPhoneType() {
      this.$emit('showExplainPhoneType')
    },
    confirmDeviceModal() {
      this.$emit('confirmDeviceModal')
    },
    returnToSelectDevice() {
      this.$emit('returnToSelectDevice')
    },
    closeConfirmDeviceModal() {
      this.$emit('closeConfirmDeviceModal')
    },
  },
}
</script>

<style lang="scss">
.confirm-device__container {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 50vh;
  background-color: #fcfdf7;
  border-radius: 7px;
  z-index: 104;
  width: 100%;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
}

.confirm-device__title {
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
}

.confirm-device__subtitle {
  font-size: 15px;
  font-weight: 400;
  text-align: center;
}

.confirm-device__close-icon {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.confirm-device__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f37053;
  color: #fff;
  padding: 10px 20px;
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
}

.confirm-device__body {
  padding: 10px 20px 20px 20px;
  font-size: 17px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.confirm-device__body__device-name {
  padding-top: 10px;
  display: block;
  text-align: center;
  font-size: 15px;
}

.confirm-device__body__device-title {
  padding-top: 10px;
  display: block;
  text-align: center;
  font-size: 20px;
}

.confirm-device__body__description {
  padding: 15px 0 5px 0px;
  text-align: center;
  color: #525252;
  font-size: 15px;
}

.confirm-device__back,
.confirm-device__next,
.confirm-device__start {
  flex: 1;
  text-align: center;
  padding: 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
  width: 80%;
}

.confirm-device__next {
  background-color: transparent;
  border: 1px solid #f37053;
  font-weight: bold;
  color: #f37053;
}

.confirm-device__back {
  background-color: #f37053;
  color: white;
  font-weight: bold;
}

.confirm-device__body__device-name__name {
  font-weight: bold;
}

.confirm-device__body__actions {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
}

.confirm-device__body__discover-device {
  padding-top: 20px;
  font-size: 14px;
  color: #f37053;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
}

@media (max-width: 390px) {
  .confirm-device__container {
    max-width: 330px;
  }
}

@media (max-width: 370px) {
  .confirm-device__container {
    max-width: 300px;
  }
}

@media (min-width: 768px) {
  .confirm-device__container {
    display: none;
  }

  .confirm-device__title {
    font-size: 16px;
  }

  .confirm-device__subtitle {
    font-size: 20px;
    margin: 14px 0px 25px 0px;
  }
}
</style>
